module.exports = __webpack_public_path__ + "img/bookshelf07.1e2c8845.jpg";